import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIntegrationIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4304_54727)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				clipPath: "url(#clip1_4304_54727)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M27 21.5V27H14.5H2V9.5V7H12L14.5 10.75H16",
					stroke: "currentColor",
					strokeWidth: 1.2,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.9513 23.0146L12.1691 15.1468L28.1126 15.5409L19.9513 23.0146Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.0638 15.7807C17.1047 14.1241 17.4715 12.4919 18.1433 10.9771C18.8151 9.46238 19.7786 8.09476 20.9789 6.95237C22.1792 5.80998 23.5927 4.9152 25.1388 4.3191C26.6849 3.72301 28.3333 3.43728 29.9898 3.47823L29.8239 10.1894C29.0487 10.1702 28.2773 10.3039 27.5538 10.5829C26.8303 10.8618 26.1688 11.2806 25.6071 11.8152C25.0454 12.3498 24.5945 12.9898 24.2801 13.6987C23.9658 14.4075 23.7941 15.1714 23.7749 15.9466L17.0638 15.7807Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4304_54727",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_4304_54727",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "currentColor"
		})
	})] })]
});
export default SvgIntegrationIcon;
